<div class="layout-boxed content">
  <div class="row">
    <div class="col-sm-12 pd-0" [innerHtml]="body"></div>
  </div>
  <div class="row">
    <div class="col-sm-12 pd-0" [innerHtml]="blockMessage"></div>
  </div>
</div>
